var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserMgmt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17096 13.5C4.30296 13.5 1 14.085 1 16.427C1 18.769 4.28196 19.374 8.17096 19.374C12.038 19.374 15.34 18.789 15.34 16.448C15.34 14.107 12.059 13.5 8.17096 13.5Z",
    stroke: "#3A4B55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17072 10.16C9.38398 10.1556 10.5459 9.67 11.4015 8.80978C12.2571 7.94956 12.7364 6.78501 12.7343 5.57175C12.7321 4.35849 12.2485 3.19566 11.3898 2.33853C10.5312 1.4814 9.36751 1 8.15424 1C6.94098 1 5.77726 1.4814 4.91859 2.33853C4.05991 3.19566 3.57641 4.35849 3.57423 5.57175C3.57204 6.78501 4.05134 7.94956 4.90693 8.80978C5.76251 9.67 6.92451 10.1556 8.13776 10.16H8.17072Z",
    stroke: "#3A4B55",
    strokeWidth: 1.429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMgmt);
export default __webpack_public_path__ + "static/media/user-mgmt.ebe4d88ae1575e671784305681ab8a43.svg";
export { ForwardRef as ReactComponent };